import { useState } from 'react';

import { Box } from '@mui/joy';

import { usePermissionsContext } from '../context/permissionsContext';

import { Navbar } from './navbar/Navbar';
import { PlatformBanner } from './PlatformBanner/PlatformBanner';

interface PropTypes {
  children: React.ReactNode;
}
const Layout = ({ children }: PropTypes) => {
  const { isVersionMismatch } = usePermissionsContext();
  const [isBannerVisible, setIsBannerVisible] = useState(false);

  // Calculate top offset based on navbar + version mismatch bar + banner
  const navbarHeight = 62;
  const versionMismatchHeight = isVersionMismatch ? 28 : 0;
  const bannerHeight = isBannerVisible ? 72 : 0;
  const totalTopOffset = navbarHeight + versionMismatchHeight + bannerHeight;

  return (
    <>
      <Navbar />
      <Box
        sx={{
          position: 'fixed',
          top: `${navbarHeight + versionMismatchHeight}px`,
          width: 1,
          zIndex: 999,
          padding: '8px 0',
        }}
      >
        <PlatformBanner onVisibilityChange={setIsBannerVisible} />
      </Box>
      <Box
        id='layout'
        sx={{
          position: 'fixed',
          top: `${totalTopOffset}px`,
          mx: 'auto',
          width: 1,
          height: `calc(100vh - ${totalTopOffset}px)`,
          overflowY: 'scroll',
        }}
      >
        {children}
      </Box>
    </>
  );
};

export { Layout };
